export const SLICE_TAGS_POSITION_NAME = "slider_tag_position";
